"use client";

import {
  DD_APPLICATION_ID,
  DD_CLIENT_TOKEN,
  DD_ENV,
  DD_SERVICE_NAME,
  DD_SESSION_REPLAY_SAMPLE_RATE,
  DD_SESSION_SAMPLE_RATE,
  DD_SITE,
  DD_TRACK_USER_INTERACTIONS,
  DD_TRACK_VIEWS_MANUALLY,
  DD_VERSION,
} from "@/modules/config";
import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

interface GlobalWindow extends Window {
  __DATADOG_INITIALIZED__?: boolean;
}

function initializeDatadog() {
  if (typeof window === "undefined") return;

  const globalWindow = window as GlobalWindow;
  if (globalWindow.__DATADOG_INITIALIZED__) return;

  if (!DD_APPLICATION_ID || !DD_CLIENT_TOKEN) {
    return;
  }

  // Check if Datadog RUM is already initialized
  try {
    if (datadogRum.getInternalContext()) {
      globalWindow.__DATADOG_INITIALIZED__ = true;
      return;
    }
  } catch {
    // Ignore errors from getInternalContext
  }

  try {
    datadogRum.init({
      applicationId: DD_APPLICATION_ID,
      clientToken: DD_CLIENT_TOKEN,
      site: DD_SITE,
      service: DD_SERVICE_NAME,
      env: DD_ENV,
      version: DD_VERSION,
      sessionSampleRate: DD_SESSION_SAMPLE_RATE,
      sessionReplaySampleRate: DD_SESSION_REPLAY_SAMPLE_RATE,
      trackUserInteractions: DD_TRACK_USER_INTERACTIONS,
      trackViewsManually: DD_TRACK_VIEWS_MANUALLY,
      defaultPrivacyLevel: "mask-user-input",
      allowedTracingUrls: [
        /https:\/\/.*\.grover\.com/,
        /https:\/\/.*\.getgrover\.com/,
      ],
    });

    datadogLogs.init({
      clientToken: DD_CLIENT_TOKEN,
      site: DD_SITE,
      env: DD_ENV,
      service: DD_SERVICE_NAME,
      forwardErrorsToLogs: true,
      sessionSampleRate: DD_SESSION_SAMPLE_RATE,
      version: DD_VERSION,
    });

    globalWindow.__DATADOG_INITIALIZED__ = true;
  } catch {
    // Ignore errors from Datadog initialization
  }
}

export { initializeDatadog };
